import { withNamespaces } from 'react-i18next';
import {
    Alert,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from 'reactstrap';

import {
    getMailboxAnalysisWarningCopy,
    getMailboxIntentItem,
} from '../../helpers';

const MessageIntentAnalysisModal = ({
    t,
    isOpen,
    session,
    analysis,
    isApplying,
    onCancel,
    onConfirm,
}) => {
    const intentItem = getMailboxIntentItem(session?.intent);
    const intentLabel = t(intentItem?.titleKey || 'Case');
    const warningCopy = getMailboxAnalysisWarningCopy(analysis, t, intentLabel)
        || t(
            'This email does not appear related to {{intent}}. Review the message before creating a case.',
            { intent: intentLabel }
        );

    return (
        <Modal
            isOpen={isOpen}
            toggle={isApplying ? undefined : onCancel}
            centered
            unmountOnClose
            className="mailbox-analysis-preview"
        >
            <ModalHeader toggle={isApplying ? undefined : onCancel}>
                {t('Review AI analysis')}
                {intentItem ? ` — ${intentLabel}` : ''}
            </ModalHeader>
            <ModalBody>
                <Alert color="warning" className="mb-0">
                    {warningCopy}
                </Alert>
            </ModalBody>
            <ModalFooter className="mailbox-analysis-preview__footer">
                <Button
                    type="button"
                    color="secondary"
                    onClick={onCancel}
                    disabled={isApplying}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    type="button"
                    color="secondary"
                    outline
                    onClick={onConfirm}
                    disabled={isApplying}
                >
                    {isApplying ? (
                        <Spinner size="sm" className="me-2" />
                    ) : null}
                    {t('Create case anyway')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(MessageIntentAnalysisModal);
